"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieConsentDomain = void 0;
function getCookieConsentDomain() {
    var metaElement = document.querySelector('meta[name="prezly:cookie_consent_domain"]');
    if (metaElement) {
        return metaElement.content;
    }
    return document.location.hostname;
}
exports.getCookieConsentDomain = getCookieConsentDomain;
//# sourceMappingURL=getCookieConsentDomain.js.map